function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminListActions = exports.AdminListActionTypes = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _AdminListTypes = require("../AdminListTypes");
var _getLocaleKey = require("../getLocaleKey");
var _components = require("../../../components");
var _styles = require("../../../styles");
var _styles2 = require("./styles");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["type", "hasItems", "hasSelectedItems", "selectAllOnPress", "deselectAllOnPress", "createOnPress", "editOnPress", "removeOnPress", "approveOnPress", "declineOnPress", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var AdminListActionTypes = exports.AdminListActionTypes = function (AdminListActionTypes) {
  AdminListActionTypes[AdminListActionTypes["selectAll"] = 0] = "selectAll";
  AdminListActionTypes[AdminListActionTypes["deselectedAll"] = 1] = "deselectedAll";
  AdminListActionTypes[AdminListActionTypes["create"] = 2] = "create";
  AdminListActionTypes[AdminListActionTypes["edit"] = 3] = "edit";
  AdminListActionTypes[AdminListActionTypes["remove"] = 4] = "remove";
  AdminListActionTypes[AdminListActionTypes["approve"] = 5] = "approve";
  AdminListActionTypes[AdminListActionTypes["decline"] = 6] = "decline";
  return AdminListActionTypes;
}({});
var AdminListActions = exports.AdminListActions = (0, _react.memo)(function (_ref) {
  var type = _ref.type,
    _ref$hasItems = _ref.hasItems,
    hasItems = _ref$hasItems === void 0 ? false : _ref$hasItems,
    _ref$hasSelectedItems = _ref.hasSelectedItems,
    hasSelectedItems = _ref$hasSelectedItems === void 0 ? false : _ref$hasSelectedItems,
    selectAllOnPress = _ref.selectAllOnPress,
    deselectAllOnPress = _ref.deselectAllOnPress,
    createOnPress = _ref.createOnPress,
    editOnPress = _ref.editOnPress,
    removeOnPress = _ref.removeOnPress,
    approveOnPress = _ref.approveOnPress,
    declineOnPress = _ref.declineOnPress,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var _useStyles = (0, _styles2.useStyles)(),
    styles = _useStyles.styles;
  var _localeKey = (0, _getLocaleKey.getLocaleKey)(type);
  var _actions = [];
  switch (type) {
    case _AdminListTypes.AdminListTypes.organizationTeams:
      _actions = [AdminListActionTypes.create, AdminListActionTypes.selectAll, AdminListActionTypes.deselectedAll, AdminListActionTypes.remove];
      break;
    case _AdminListTypes.AdminListTypes.organizationMembers:
      _actions = [AdminListActionTypes.selectAll, AdminListActionTypes.deselectedAll, AdminListActionTypes.edit, AdminListActionTypes.remove];
      break;
    case _AdminListTypes.AdminListTypes.organizationPendingMembers:
      _actions = [AdminListActionTypes.selectAll, AdminListActionTypes.deselectedAll, AdminListActionTypes.approve, AdminListActionTypes.decline];
      break;
    case _AdminListTypes.AdminListTypes.teamMembers:
      _actions = [AdminListActionTypes.selectAll, AdminListActionTypes.deselectedAll, AdminListActionTypes.edit, AdminListActionTypes.remove];
      break;
    case _AdminListTypes.AdminListTypes.teamPendingMembers:
      _actions = [AdminListActionTypes.selectAll, AdminListActionTypes.deselectedAll, AdminListActionTypes.approve, AdminListActionTypes.decline];
      break;
  }
  if (_actions.length === 0) return null;
  return (0, _jsxRuntime.jsx)(_components.View, Object.assign({
    style: [styles.container, style],
    spacer: spacing.xs,
    testID: "AdminListActions"
  }, props, {
    children: _actions.map(function (action) {
      switch (action) {
        case AdminListActionTypes.selectAll:
          return (0, _jsxRuntime.jsx)(_components.Button, {
            hideLabel: true,
            label: t("adminListActions:".concat(_localeKey, ".selectAll")),
            type: _components.ButtonType.iconOutlined,
            icon: _components.Icons.SelectAll,
            onPress: selectAllOnPress,
            state: {
              disabled: !hasItems
            }
          }, action);
        case AdminListActionTypes.deselectedAll:
          return (0, _jsxRuntime.jsx)(_components.Button, {
            hideLabel: true,
            label: t("adminListActions:".concat(_localeKey, ".deselectAll")),
            type: _components.ButtonType.iconOutlined,
            icon: _components.Icons.DeselectAll,
            onPress: deselectAllOnPress,
            state: {
              disabled: !hasItems || !hasSelectedItems
            }
          }, action);
        case AdminListActionTypes.create:
          return (0, _jsxRuntime.jsx)(_components.Button, {
            hideLabel: true,
            label: t("adminListActions:".concat(_localeKey, ".create")),
            type: _components.ButtonType.iconOutlined,
            icon: _components.Icons.Plus,
            onPress: createOnPress
          }, action);
        case AdminListActionTypes.edit:
          return (0, _jsxRuntime.jsx)(_components.Button, {
            hideLabel: true,
            label: t("adminListActions:".concat(_localeKey, ".edit")),
            type: _components.ButtonType.iconOutlined,
            icon: _components.Icons.Edit,
            onPress: editOnPress,
            state: {
              disabled: !hasItems || !hasSelectedItems
            }
          }, action);
        case AdminListActionTypes.remove:
          return (0, _jsxRuntime.jsx)(_components.Button, {
            hideLabel: true,
            label: t("adminListActions:".concat(_localeKey, ".remove")),
            type: _components.ButtonType.iconOutlined,
            icon: _components.Icons.Bin,
            onPress: removeOnPress,
            state: {
              disabled: !hasItems || !hasSelectedItems
            }
          }, action);
        case AdminListActionTypes.approve:
          return (0, _jsxRuntime.jsx)(_components.Button, {
            hideLabel: true,
            label: t("adminListActions:".concat(_localeKey, ".approve")),
            type: _components.ButtonType.iconOutlined,
            icon: _components.Icons.TickThin,
            onPress: approveOnPress,
            state: {
              disabled: !hasItems || !hasSelectedItems
            }
          }, action);
        case AdminListActionTypes.decline:
          return (0, _jsxRuntime.jsx)(_components.Button, {
            hideLabel: true,
            label: t("adminListActions:".concat(_localeKey, ".decline")),
            type: _components.ButtonType.iconOutlined,
            icon: _components.Icons.Bin,
            onPress: declineOnPress,
            state: {
              disabled: !hasItems || !hasSelectedItems
            }
          }, action);
      }
    })
  }));
});